var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventEmitter } from 'events';
import { AuthApiMutation } from '../../../infra/api';
import { ChurnZeroService, BOOK_APPOINTMENT, PLATFORM } from '../../../infra/observability/churnzero';
var AddAppointmentMutation = /** @class */ (function (_super) {
    __extends(AddAppointmentMutation, _super);
    function AddAppointmentMutation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayErrors = true;
        return _this;
    }
    AddAppointmentMutation.prototype.afterMutationSuccess = function () {
        EventEmitter.prototype.emit('appointment-saved');
        ChurnZeroService.track(BOOK_APPOINTMENT, PLATFORM);
    };
    AddAppointmentMutation.prototype.request = function (payload) {
        var options = this.buildOptions();
        return this.http.post('/v1/appointment', __assign(__assign({}, payload.appointment), { platform: 'Commander' }), options);
    };
    return AddAppointmentMutation;
}(AuthApiMutation));
export { AddAppointmentMutation };
